export const logOutDictionary = {
  logOut: 'Siz aniq chiqishni xohlaysizmi?',
  hasUploadingFiles: 'Fayl yuklanish jarayonida. Operatsiyani bajarishga aminmisiz?',
  exit: 'Chiqish',
}
